export default __webpack_public_path__ + "static/media/feet.f7459a9e.ogg";